import { useEffect, useRef } from "react";
import { api, API } from "@/lib/api";

const queue = [];
let timer = null;

function flush() {
  const events = queue.splice(0, 50);
  if (!events.length) return;
  const body = JSON.stringify({ events });
  try {
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/featured/metrics`, new Blob([body], { type: "application/json" }));
    else api.post("/featured/metrics", { events }).catch(() => {});
  } catch { /* métricas nunca bloqueiam a UI */ }
}

export function trackFeatured(targetType, targetId, kind) {
  if (!targetType || !targetId) return;
  if (kind === "impression") {
    const key = `fimp:${targetType}:${targetId}:${Math.floor(Date.now() / 3600000)}`;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch { /* storage indisponível */ }
  }
  queue.push({ target_type: targetType, target_id: targetId, kind });
  clearTimeout(timer);
  timer = setTimeout(flush, 1500);
}

export function useFeaturedImpression(targetType, targetId, active) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!active || !el || typeof IntersectionObserver === "undefined") return;
    const obs = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting && e.intersectionRatio >= 0.5)) { trackFeatured(targetType, targetId, "impression"); obs.disconnect(); }
    }, { threshold: 0.5 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [targetType, targetId, active]);
  return ref;
}

export function featuredClickProps(item, targetType) {
  return item?.featured_active ? { onClick: () => trackFeatured(targetType, item.id, "click") } : {};
}
